




  import Vue from 'vue'
  import { Component, Prop } from 'nuxt-property-decorator'
  import OneCmsDynamicComponent from '~/components/organisms/grid/shared/OneCmsDynamicComponent.vue'

  @Component({
    components: {
      OneCmsDynamicComponent,
    },
  })
  export default class OneProductTitleWithLabels extends Vue {
    name: string = 'one-cms-product-title-with-labels'

    @Prop({
      required: true,
      type: String,
    })
    readonly html!: string
  }
